import React from 'react';
import { Row, Col } from 'antd';
import { Title } from '@/components/Typography';
import { useParams } from 'react-router-dom';

export function Header() {
	const { id } = useParams<{ id: string }>();
	const title: string = !!id ? 'Edit extraction' : 'New extraction';

	return (
		<Row justify="start">
			<Col>
				<Title level={3}>{title}</Title>
			</Col>
		</Row>
	);
}
